module.exports = __webpack_public_path__ + "img/background.f2578eab.webp";